import React from 'react';
import { motion } from 'framer-motion';
import { PlayCircleIcon, BookOpenIcon, ListChecksIcon, LightbulbIcon } from 'lucide-react';
const features = [{
  icon: BookOpenIcon,
  title: 'Instrucciones paso a paso',
  description: 'Explicadas vuelta por vuelta, sin dar nada por sentado.'
}, {
  icon: PlayCircleIcon,
  title: 'Fotos detalladas',
  description: 'Imágenes de cada paso para que no te pierdas ningún detalle del proceso.'
}, {
  icon: ListChecksIcon,
  title: 'Lista de materiales',
  description: 'Todo lo que necesitás para empezar, con recomendaciones de hilos y agujas.'
}, {
  icon: LightbulbIcon,
  title: 'Tips y consejos',
  description: 'Trucos de tejido para lograr terminaciones prolijas y resultados profesionales.'
}];
export function Preview() {
  return <section className="bg-ink py-16 text-cream sm:py-24" aria-labelledby="preview-title" data-id="element-126" data-mp="19y8y74849g60">
      <div className="mx-auto max-w-6xl px-5" data-id="element-127" data-mp="151s7c29j8np8">
        <div className="text-center" data-id="element-128" data-mp="335o3iv2pivby">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-terracotta-light" data-id="element-129" data-mp="334mroodva4t6">
            Un vistazo por dentro
          </span>
          <h2 id="preview-title" className="mt-4 font-display text-3xl font-black leading-tight sm:text-4xl" data-id="element-130" data-mp="37yh55a2vpnjt">
            Mirá un poco del método y lo que vas a encontrar
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-lg text-cream/70" data-id="element-131" data-mp="3lwf8lkfnvzkj">
            Diseñamos cada página para que sea visual, clara y fácil de seguir. Olvidate de los
            textos aburridos y los diagramas incomprensibles.
          </p>
        </div>

        <div className="mt-12 grid gap-12 lg:grid-cols-[1fr_0.8fr] lg:items-center lg:gap-16" data-id="element-132" data-mp="3bxgct2fzvyey">
          <motion.div initial={{
          opacity: 0,
          scale: 0.96
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          amount: 0.3
        }} transition={{
          duration: 0.6
        }} className="relative mx-auto w-full max-w-md overflow-hidden rounded-[2rem] border-8 border-white/10 shadow-2xl lg:max-w-none" data-id="element-133" data-mp="3gvht5fm1djmq">
            <video src="https://cdn.magicpatterns.com/uploads/vFPPu6Avwy24aRneEADbQP/pantallaso amigurini 2.mov" autoPlay loop muted playsInline className="h-full w-full object-cover" poster="https://cdn.magicpatterns.com/uploads/1nj74hxvd6gPxmA1Sf9D1m/ChatGPT_Image_10_ago_2026,_04_40_13_p.m..png" data-id="element-134" data-mp="6zu2jox4tpfp" />
            <div className="absolute inset-0 rounded-[1.5rem] ring-1 ring-inset ring-white/20" data-id="element-135" data-mp="3kdxbi6lszneo" />
          </motion.div>

          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-1" data-id="element-136" data-mp="3fgfbx6toekjc">
            {features.map((feature, index) => <motion.div key={feature.title} initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            amount: 0.4
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="flex gap-4 rounded-2xl bg-white/5 p-5" data-id="element-137" data-mp="3aiwzv7kd3p74" data-mpi={index}>
                <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-terracotta/20 text-terracotta-light" data-id="element-138" data-mp="1l6qoyu9758ip">
                  <feature.icon className="h-6 w-6" aria-hidden="true" data-id="element-139" data-mp="1q14eig16glfg" />
                </div>
                <div data-id="element-140" data-mp="1uzpeqfgfj53w">
                  <h3 className="font-display text-lg font-bold text-white" data-id="element-141" data-mp="xacmlur5aixx">{feature.title}</h3>
                  <p className="mt-1 text-sm leading-relaxed text-cream/70" data-id="element-142" data-mp="128xmtu6ed2md">
                    {feature.description}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}